<template>
  <div class="carousel-wrapper">
    <div class="carousel" ref="carousel">
      <slot />
    </div>
    <div aria-controls="slides-section" v-if="!customBtns">
      <div class="carousel-button" tabindex="-1">
        <a
          @click="previous"
          @keypress.enter.space="previous"
          tabindex="0"
          role="button"
          aria-label="Previous"
        >
          <span class="font-icon-arrow-left" alt="Previous"></span>
        </a>
      </div>
      <div class="carousel-button">
        <a
          @click="next"
          @keypress.enter.space="next"
          tabindex="0"
          role="button"
          aria-label="Next"
        >
          <span class="font-icon-arrow-right" alt="Next"></span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import slideMixin from './slideMixin';

export default {
  name: 'Carousel',
  mixins: [slideMixin],
  mounted() {
    this.slide();
  },
  props: {
    customBtns: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
